// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const BE_HOST_API = process.env.REACT_APP_BE_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;
export const LIVERATE_API = process.env.REACT_APP_LIVERATE_API;

export const IS_PROD = process.env.REACT_APP_IS_PROD;

export const SOCKET_LINK = process.env.REACT_APP_SOCKET_LINK;
export const SOCKET_SECRET_KEY = process.env.REACT_APP_SECRET_KEY ?? 'roll888_session';
export const SOCKET_OPTIONS = {
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 500,
  reconnectionAttempts: Infinity,
  forceNew: true,
  transports: ['websocket'],
  timeout: 10000,
};

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.sports.root; // as '/dashboard'

export const ERROR_MSG = new Error('Something Went Wrong !!!');

export const SWR_CONFIG = {
  refreshInterval: 0,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  keepPreviousData: true,
};
